module.exports = __webpack_public_path__ + "static/je-7e5795cff03c9ce9311c005aa422330f.svg";